import React, { useRef, useState } from "react";

const ClientCarousel = ({ data }) => {
  let NoofClients = 38;
  const scrollRef = useRef(null);

  const handleMouseEnter = () => {
    if (scrollRef.current) {
      scrollRef.current.style.animationPlayState = "paused";
    }
  };

  const handleMouseLeave = () => {
    if (scrollRef.current) {
      scrollRef.current.style.animationPlayState = "running";
    }
  };

  return (
    <div className="2xl:container w-full md:px-10 lg:px-20  px-6 mb-16 sm:mb-20 ">
      <div className=" w-full   pt-8 md:pt-[56px]  border-[1px] border-journyborder  shadow-services rounded-[32px]">
        <div className="flex flex-col items-center">
          <h2 className=" px-4 text-20 sm:text-2t md:text-32  text-primarycolor font-semibold text-center">
            {data.Title}
          </h2>
          {data.Title2 ? (
            <h3 className="text-20 sm:text-24 md:text-32 text-center">
              {data.Title2}
            </h3>
          ) : (
            ""
          )}
        </div>
        <div className="w-full flex justify-center px-10  py-10 md:py-[64px]">
          <div className="flex relative w-full overflow-hidden ">
            <div
              ref={scrollRef}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              className="flex w-clientcarousel gap-20 animate-scroll"
            >
              {Array.from({ length: NoofClients }, (_, index) => (
                <div
                  key={index}
                  className="min-w-fit max-w-[250px] flex justify-center gap-5"
                  style={{}}
                >
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      `/images/clientlogos/client${(index % 19) + 1}.svg`
                    }
                    alt="publishing_client_logo"
                    className="mx-auto my-auto"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientCarousel;
